module.exports = __webpack_public_path__ + "img/symbol_7.3ca2e05b.png";